<template>
  <NuxtLinkLocale :to="data?.fields?.urlLink">
    <span :class="$style.name">{{ data?.fields?.milestoneName }}</span>
    <span :class="$style.date">{{ computedDates }}</span>
  </NuxtLinkLocale>
</template>

<script setup lang="ts">
import type { TypeMilestoneWithoutUnresolvableLinksResponse } from '~/types/contentful'

const { locale } = useI18n()

const props = defineProps<{
  data: TypeMilestoneWithoutUnresolvableLinksResponse
}>()

const computedDates = computed(() => {
  let dates = ''
  if (props.data?.fields?.startDate) {
    const startDate = formatLocalizedDate(
      props.data?.fields?.startDate,
      'PP',
      locale?.value,
    )
    dates = `${startDate}`
  }
  if (props.data?.fields?.endDate) {
    const endDate = formatLocalizedDate(
      props.data?.fields?.endDate,
      'PP',
      locale?.value,
    )
    dates = `${dates} - ${endDate}`
  }
  return dates
})
</script>

<style lang="scss" module>
.name {
  font-weight: bold;
  display: block;
  margin-bottom: 0.25em;
}

.date {
  font-size: to-rem(16px);
  font-style: italic;
  font-weight: normal;
  text-transform: uppercase;
}
</style>
